import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import { Filters } from '../../../../constants/filter/filters';

function onChangeCallbackFactory(props) {
    return (value, filterName, selectProps) => {
        const valueAsNumber = parseInt(value, 10) || 0;
        props.onMinPriceChange(valueAsNumber, filterName, selectProps);
    };
}

function Price(props) {
    const onChangeCallback = onChangeCallbackFactory(props);
    const opened = props.opened || props.minPriceValue !== '0' || props.maxPriceValue !== '0';

    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline='catalog-filters-section-headline-price'
            containerModifier="price"
        >
            <FilterSelect
                name={Filters.PRICE_MIN}
                value={props.minPriceValue}
                options={props.minPriceOptions}
                labelTranslationKey="catalog-filters-price-min-select-label"
                provideAllTranslationKey="catalog-filters-price-no-min-select-label"
                onChange={onChangeCallback}
                provideAllOption={true}
                highlight={props.maxPriceValue !== '0' && props.minPriceValue === '0'}
                showTooltip={false}
            />

            <FilterSelect
                name={Filters.PRICE_MAX}
                value={props.maxPriceValue}
                options={props.maxPriceOptions}
                labelTranslationKey="catalog-filters-price-max-select-label"
                provideAllTranslationKey="catalog-filters-price-no-max-select-label"
                onChange={onChangeCallback}
                provideAllOption={true}
                highlight={props.maxPriceValue === '0'}
                showTooltip={false}
            />
        </FilterSection>
    );
}

Price.propTypes = {
    minPriceValue: PropTypes.string.isRequired,
    maxPriceValue: PropTypes.string.isRequired,
    minPriceOptions: PropTypes.array.isRequired,
    maxPriceOptions: PropTypes.array.isRequired,
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onMinPriceChange: PropTypes.func.isRequired,
    onMaxPriceChange: PropTypes.func.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
};

export { Price };
